import { faCircleCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
} from '@repo/videa-components/src/index';

interface Props {
  onOpenOnboarding?: () => void;
}

export const TrialSuccessAlert = ({ onOpenOnboarding }: Props) => {
  return (
    <Alert variant="successSolid">
      <FontAwesomeIcon icon={faCircleCheck} />
      <AlertTitle>Success</AlertTitle>
      <AlertDescription className="vai-flex vai-flex-col vai-gap-2">
        <Trans>
          Your trial has been started. You will see AI on the next patient you
          open.
        </Trans>
        {onOpenOnboarding && (
          <Button
            className="vai-w-full !vai-bg-white !vai-text-green-700 hover:!vai-bg-green-50"
            onClick={onOpenOnboarding}
            variant="secondary"
          >
            <Trans>Watch onboarding video</Trans>
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
